import Send from "@mui/icons-material/Send";
import { ScheduleButton } from "./schedule-button";

import type { ScheduleButtonProps } from "./schedule-button";
import type { FC } from "react";

export const ScheduleImmediateButton: FC<Omit<ScheduleButtonProps, "icon" | "title">> = (props) => (
  <ScheduleButton icon={<Send />} title="Send immediately" {...props} />
);
